/**
 * Mobile Video Player Module
 * @module mobileVideoPlayer
 *
 * Handles click-to-overlay video behavior for mobile PDP Size & Fit tab.
 * No floating/dragging logic — opens a full-screen overlay instead.
 */

import $ from 'jquery';
import './custom-video-player';
import registerJQueryPlugin from '../../lib/register-jquery-plugin';
import mergeOptions from '../../lib/merge-options';

export const PLUGIN_NAME = 'mobileVideoPlayer';
export const DEFAULTS = {
  videoMuted: false,
  hideMute: true, // renders the mute/volume button in the overlay (flag is inverted)
  $originalTrigger: $(),
  titleClass: 'floating-video__title',
  captionClass: 'floating-video__caption',
};

const createOverlayHTML = (videoUrl, videoPosterUrl) => $(`
  <div class="mobile-video-player js-mobile-video-player">
    <button class="mobile-video-player__close js-mobile-video-player__close" type="button" aria-label="Close video">
      <span class="icon icon--x icon--md">
        <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
          <path d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z"/>
        </svg>
      </span>
    </button>
    <video class="u-full-width" poster="${videoPosterUrl}" playsinline loop>
      <source src="${videoUrl}" type="video/mp4">
    </video>
  </div>
`);

const showVideo = ($el, options) => {
  const videoUrl = $el.data('videoUrl');
  const videoPosterUrl = $el.data('videoPosterUrl');
  const $overlay = createOverlayHTML(videoUrl, videoPosterUrl);
  const $video = $overlay.find('video');
  const $closeButton = $overlay.find('.js-mobile-video-player__close');

  $('.js-mobile-video-player').remove();
  $('body').append($overlay).addClass('u-overflow--hidden');

  $closeButton.on('click', () => {
    $overlay.remove();
    $('body').removeClass('u-overflow--hidden');
  });

  $video.customVideoPlayer(options);

  $overlay.find('.custom-video__container').addClass('custom-video__container--controls-visible');
  const videoEl = $video[0];
  if (videoEl) {
    const playPromise = videoEl.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(() => {});
    }
  }
};

const openVideoFromTrigger = (el) => {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, {}, $el);
  opts.$originalTrigger = $el;
  showVideo($el, opts);
};

const TAP_MOVE_TOLERANCE = 15;
let delegationBound = false;

const bindTriggerDelegation = () => {
  if (delegationBound) return;
  delegationBound = true;

  let touchStartX = 0;
  let touchStartY = 0;
  let touchMoved = false;
  let openedByTouch = false;
  const TRIGGER_SELECTOR = '.js-mobile-video-trigger';

  $(document)
    .on('touchstart.mobileVideoPlayer', TRIGGER_SELECTOR, (e) => {
      const touch = e.originalEvent.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchMoved = false;
    })
    .on('touchmove.mobileVideoPlayer', TRIGGER_SELECTOR, (e) => {
      const touch = e.originalEvent.touches[0];
      if (Math.abs(touch.clientX - touchStartX) > TAP_MOVE_TOLERANCE
        || Math.abs(touch.clientY - touchStartY) > TAP_MOVE_TOLERANCE) {
        touchMoved = true;
      }
    })
    .on('touchend.mobileVideoPlayer', TRIGGER_SELECTOR, (e) => {
      if (touchMoved) return;
      // Suppress the compatibility mouse/click so the click handler below does
      // not fire a second time on touch.
      e.preventDefault();
      openedByTouch = true;
      window.setTimeout(() => { openedByTouch = false; }, 500);
      openVideoFromTrigger(e.currentTarget);
    })
    .on('click.mobileVideoPlayer', TRIGGER_SELECTOR, (e) => {
      if (openedByTouch) return;
      openVideoFromTrigger(e.currentTarget);
    });
};

export default function mobileVideoPlayer() {
  // Options are read per-trigger at event time, so the plugin call just
  // ensures the delegated listeners exist.
  bindTriggerDelegation();
  return {};
}
registerJQueryPlugin(PLUGIN_NAME, mobileVideoPlayer);

bindTriggerDelegation();


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/mobile-video-player.js